import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const Root = styled.div`
  ${(p) => p.$axis === 'horizontal'
    ? responsive('width', p.$size, p.theme)
    : responsive('height', p.$size, p.theme)}
  ${(p) => p.$axis === 'horizontal' ? css`height: 1px;` : css`width: 1px;`}
  flex: 0 0 auto;
`

export function Spacer({ axis = 'vertical', size = "20px" }) {
  return (
    <Root $axis={axis} $size={size} />
  )
}
